module.exports = __webpack_public_path__ + "static/media/CS1 -- 6.1.0dc66ae9.png";